import React from 'react';
import ModuleLayout from '../../layouts/ModuleLayout';
import { SupplierList } from '../../components/Admin/Inventory/Suppliers';

export default function SuppliersPage() {
  return (
    <ModuleLayout>
      <SupplierList />
    </ModuleLayout>
  );
}
